// [ai] /play/:id?t= — the old standalone player page: the recording opens paused in the bar with its transcript, the page names it.
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router";
import { fmt } from "../core/time";
import { usePlayerCtl } from "../player/context";
import { usePlayer } from "../stores/player";
export function PlayPage() {
  const p = usePlayerCtl(); const { id = "" } = useParams(); const [sp] = useSearchParams(); const t = +(sp.get("t") || 0); const item = usePlayer(s => s.now.item); const ready = usePlayer(s => s.ready);
  useEffect(() => { if (!ready || !id) return; void p.open({ kind: "rec", id, t, e: null }, { play: false }).then(() => { if (p.item?.id === id) p.togglePanel(true, { persist: false }); }); }, [p, id, t, ready]);
  const it = item?.id === id ? item : null;
  return <div className="at-page"><div className="at-eyebrow">Listen</div><h1>{it?.title ?? "Recording"}</h1>{it ? <p className="at-sub">{[it.date, fmt(it.duration), it.folder.split("/").slice(1).join(" › ")].filter(Boolean).join(" · ")}</p> : null}</div>;
}
